import { Component, Injector } from '@angular/core';
import { SecurityDataService } from '../../../../submodules/angular-common/security-data.service';
import { appearance } from '../../../../config/appearance';
import { BaseView } from '../../base-view';
import { RoutingDataService } from 'src/app/submodules/angular-common/routing-data.service';
import { NAVIGATION_TREE } from 'src/app/config/navigation-tree';
import { CanvasLayoutDataService } from 'src/app/submodules/angular-common/canvas-layout-data.service';

@Component({
  selector: 'app-public-area-canvas',
  templateUrl: './public-area-canvas.component.html',
  styleUrls: ['./public-area-canvas.component.scss']
})
export class PublicAreaCanvasComponent extends BaseView {

  menuOptions = NAVIGATION_TREE.filter(el=>el.showInPublicMenu);

  constructor(
     public securityDataService: SecurityDataService,
     public routingDataService: RoutingDataService,
     protected _injector: Injector
  ) {
    super(_injector);
    this._injector.get(CanvasLayoutDataService).headerHeight = appearance.publicArea.header.height;
    this._injector.get(CanvasLayoutDataService).bgUrl = appearance.publicArea.bgUrl;
    this._injector.get(CanvasLayoutDataService).bgColor = appearance.publicArea.bgColor; 
  }
}
